<div class="row">
  <div class="col-xs-12">
    <div class="small footer-default">
      {{ 'PARTECIPANT_LTI.RESULTS.SELECT_YEAR' | translate }}
    </div>
    <select
      id="selectYearEl"
      class="form-control"
      name="sel-activity"
      [(ngModel)]="currentYear"
    >
      <option *ngFor="let year of getYears()" [ngValue]="year">
        {{ year }}
      </option>
    </select>

    <div id="widgetsContainer">
      <div id="bonusBank" class="widget collapsed">
        <div class="widgetHeader">
          <div class="widgetHeaderInfo">
            <div class="small widgetTitle">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.TITLE' | translate
              }}
            </div>
            <div class="veryBig widgetAmount">
              {{ formatNumber(getBonusBankClosing(currentYear)) }}
            </div>
          </div>
        </div>

        <div class="widgetBody">
          <div class="display-flex-left">
            <div class="text-bold width-30perc">
              {{ 'ADMIN_LTI.RESULTS.BONUS_BANK_OPENING' | translate }}
            </div>
            <progressbar
              type="warning"
              [value]="getBonusBankOpening(currentYear)"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="" style="width: 50px; padding-left: 10px">
              {{ formatNumber(getBonusBankOpening(currentYear)) }}
            </div>
          </div>
          <div class="display-flex-left">
            <div class="width-30perc">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_BANK_WIDGET.PAST_PAYABLE'
                  | translate
              }}
            </div>
            <progressbar
              type="grey"
              [value]="getBonusBankPastPayable()"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="" style="width: 50px; padding-left: 10px">
              {{ formatNumber(getBonusBankPastPayable()) }}
            </div>
          </div>
          <div class="display-flex-left">
            <div class="width-30perc">
              {{ currentYear }}
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                  | translate
              }}
            </div>
            <progressbar
              type="warning"
              [value]="getBonusBankDeferred()"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="" style="width: 50px; padding-left: 10px">
              {{ formatNumber(getBonusBankDeferred()) }}
            </div>
          </div>
          <div class="display-flex-left">
            <div class="text-bold width-30perc">
              {{ 'ADMIN_LTI.CORRECTIVE.BODY.ROLLING_BONUS_BANK' | translate }}
            </div>
            <progressbar
              type="warning"
              [value]="getBonusBankRolling(currentYear)"
              [max]="getMax(currentYear)"
            ></progressbar>
            <div class="text-bold" style="width: 50px; padding-left: 10px">
              {{ formatNumber(getBonusBankRolling(currentYear)) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
